import { lazy } from 'react';

import lazyRoute from '../tools/lazyRoute';

export default lazyRoute(lazy(() => import('../components/Case/CaseCreation/CaseCreationContainer')));
